import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=216f3d18&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216f3d18"]])

export default __exports__